export default {
  emojiPicker: {
    search: "Search emoji",
    more: "More emoji",
    loadError: "Couldn't load the emoji.",
    retry: "Try again",
    group: {
      recent: "Frequently used",
      smileys: "Smileys & people",
      nature: "Animals & nature",
      food: "Food & drink",
      travel: "Travel & places",
      activities: "Activities",
      objects: "Objects",
      symbols: "Symbols",
      flags: "Flags"
    }
  }
};
